<template>
  <div >
    <h5>Evaluation detail: {{evaluationName}}</h5>
    <table class="table">
      <thead class="thead-dark">
        <tr>
          <th scope="col">Dataset</th>
          <th scope="col">Win%</th>
          <th scope="col">Run</th>
          <th scope="col">Percentile</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="evaluation in evaluations" v-bind:key='evaluation._id'>
          <td id="nameCell" >{{evaluation.dataset.number}} </td>
          <td>{{evaluation.winPercentage}}</td>
          <td>{{evaluation.dataset.runDate}}</td>
          <td>{{evaluation.percentile}}</td>
        </tr>
      </tbody>
    </table>
    <button type="button" class="btn btn-outline-light" @click="back()">Hide</button>
  </div>
</template>

<script>
export default {
  name: 'EvaluationDetail',
  props: {
    evaluations: Array,
    evaluationName: String,

  },
  data () {
    return {
      title: 'EvaluationDetail'
    }
  },
  methods: {
    back () {
      this.$emit ('backFromDetail', false)
    }
  },
  mounted () {
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#nameCell {
  font-size: 10pt
}
</style>
